export default function parseBoolean(value: string | null) {
  return value === 'true';
}
